import * as React from 'react';
import { groupByReturnArray } from '../../../common/functions/helperFunctions';
import { IngredientSideEffectModel } from "../../../models/ingredientSideEffectModel";
import { IngredientSideEffectReactionModel } from "../../../models/ingredientSideEffectReactionModel";
import MedicineService from '../../../services/medicineService';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import { connect } from 'react-redux';

interface IProps {
  medicineId: any,
  lang: string,
}

interface IState {
  isLoading: boolean;
  medicineId: number;
  error: any;
  sideEffects: IngredientSideEffectModel | null;
}

class sideEffectsTab extends React.Component<IProps, IState> {
  medicineService = new MedicineService(this.props.lang);

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      medicineId: this.props.medicineId,
      sideEffects: null
    };
  }

  componentDidMount() {
    this.getSideEffects();
  }

  getSideEffects = () => {
    this.setState({
      isLoading: true
    });

    this.medicineService.getSideEffects(this.state.medicineId, this.props.lang).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          sideEffects: data.data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  public render() {
    const { medicineId, isLoading, error } = this.state;

    let sideEffectContent: IngredientSideEffectModel | null;
    if (this.state.sideEffects) {
      sideEffectContent = this.state.sideEffects;
    } else {
      sideEffectContent = null;
    }

    let sideEffectElement: any;
    let sideEffectDescrContent: any;
    let sideEffectDataList: Array<any> | null = [];
    let sideEffectFooter: any;
    if (sideEffectContent) {
      sideEffectDescrContent =
        <div>
          {/* <h4>{Translate('Summary')}</h4>
          <div dangerouslySetInnerHTML={{ __html: sideEffectContent.summary }}></div>

          <h4>{Translate('For the Consumer')}</h4>
          <div dangerouslySetInnerHTML={{ __html: sideEffectContent.consumerDescription }}></div> */}
          <h4>{Translate('Overview')}</h4>
          <div dangerouslySetInnerHTML={{ __html: sideEffectContent.professionalDescription }}></div>

          <h4>{Translate('Overdose Description')}</h4>
          <div dangerouslySetInnerHTML={{ __html: sideEffectContent.overdoseDescription }}></div>

        </div>;

      if (sideEffectContent.ingredientSideEffectReactions && sideEffectContent.ingredientSideEffectReactions.length > 0) {
        let grouped = groupByReturnArray(sideEffectContent.ingredientSideEffectReactions, 'anatomicalSystemId');
        for (var i = 0; i < grouped.length; i++) {
          let groupArray: Array<IngredientSideEffectReactionModel> = grouped[i];

          let currentGroupTitle: any = {};
          if (groupArray) {
            let groupHeader = groupArray[0].anatomicalSystem ? groupArray[0].anatomicalSystem.anatomicalSystemName : null;
            currentGroupTitle = <p key={i} style={{ fontSize: 20 }}><strong>{groupHeader}</strong></p>;
          } else {
            continue;
          }

          var currentGroup: any = {};
          var currentGroupData = groupArray.map(m =>
            <p key={m.ingredientSideEffectReactionId}>
              <strong>{Translate(m.frequencyOfReaction.frequencyName)}</strong>
              {m.frequencyOfReaction.frequencyDescription ? " (" + Translate(m.frequencyOfReaction.frequencyDescription) + ")" : null}: {m.description}
            </p>
          );
          currentGroup =
            <div key={currentGroupTitle.key}>
              {currentGroupTitle}
              {currentGroupData}
            </div>

          sideEffectDataList.push(currentGroup);
        }
      }
      else {
        sideEffectDataList = null;
      }

      if (sideEffectContent.otherInformation) {
        sideEffectFooter =
          <div>
            <h4>{Translate('Other Information')}</h4>
            <div dangerouslySetInnerHTML={{ __html: sideEffectContent.otherInformation }}></div>
          </div>;
      }
      else {
        sideEffectFooter = null;
      }
    } else {
      sideEffectDescrContent = null;
    }

    sideEffectElement =
      <div>
        {sideEffectDescrContent}
        {sideEffectDataList}
        {sideEffectFooter}
      </div>

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
        {sideEffectElement}
      </div>

    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(sideEffectsTab);